import { render, staticRenderFns } from "./SendMessages.vue?vue&type=template&id=17379715"
import script from "./SendMessages.vue?vue&type=script&lang=js"
export * from "./SendMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17379715')) {
      api.createRecord('17379715', component.options)
    } else {
      api.reload('17379715', component.options)
    }
    module.hot.accept("./SendMessages.vue?vue&type=template&id=17379715", function () {
      api.rerender('17379715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/SendMessages.vue"
export default component.exports